import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';

const queryLang = new URLSearchParams(window.location.search).get('lang');
const initialLanguage = queryLang === 'en' || queryLang === 'ar'
  ? queryLang
  : (localStorage.getItem('language') || 'ar');

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    lng: initialLanguage,
    fallbackLng: 'ar',
    interpolation: { 
      escapeValue: false 
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;